import React from "react";
import { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { useI18n } from "../../lib/i18n/i18n_provider";

import { CapacityOption } from "../template_offering_listing_base";
import { TemplateOfferingListingMeetingRoom } from "../template_offering_listing_meeting_room";
import { useMDotAnalytics } from "./mdot_analytics";
import { partnerConfig } from "./mdot_partner_config";

const Theme = lazyWithRetry(() => import("./mdot_theme"));

const capacityOptions: CapacityOption[] = [
  { label: "1 - 10", value: { minCapacity: 1, maxCapacity: 10 } },
  { label: "10+", value: { minCapacity: 11 } },
];

export function OfferingMDotListingMeetingRoom() {
  useMDotAnalytics();
  const { locale } = useI18n();

  const descriptionEN = `Fully equipped meeting rooms are at your disposal on Sunday – Thursday, 8:30 am to 5:30 pm.
                          We will be happy to have you as our guests and provide you with an optimal work environment.
                          Check in to a meeting room in two easy steps and assure yourself a productive and pleasant workday.`;
  const descriptionHE = `הזמינו חדר ישיבות בשני צעדים פשוטים ובאישור מיידי.
                          חדרי הישיבות שלנו עומדים לרשותכם בימים א' - ה' בין השעות 08:30 - 17:30 .
                          נשמח לארח אתכם אצלנו ולספק לכם תנאים אופטימליים לעבודה בסביבה נעימה ומזמינה.`;

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingListingMeetingRoom
        filterConfig={{ capacity: true, location: true, capacityOptions }}
        partnerConfig={partnerConfig}
        data={{
          title:
            locale.baseLanguageTag === "en" ? "Meeting Rooms" : "חדרי ישיבות",
          description:
            locale.baseLanguageTag === "en" ? descriptionEN : descriptionHE,
        }}
      />
    </Fragment>
  );
}
